<template>
    <header class="navbar-header">
      <!-- Barra superior con fecha y hora -->
      <div class="top-bar">
        <span>{{ fechaActual }}</span> - <span>{{ horaActual }}</span>
      </div>
  
      <!-- Menú principal -->
      <nav class="navbar">
        <div class="logo">
          <img src="@/assets/logoo.png" alt="Logo" />
          <span class="brand-name"> <strong></strong></span>
        </div>
  
        <div class="hamburger" @click="toggleMenu">
          <span :class="{ open: isOpen }"></span>
          <span :class="{ open: isOpen }"></span>
          <span :class="{ open: isOpen }"></span>
        </div>
  
        <ul class="nav-links" ref="menuRef" :class="{ show: isOpen }">
          <li><a href="#inicio">Inicio</a></li>
          <li><a href="#invitaciones">Invitaciones</a></li>
          <li><a href="#contacto">Contacto</a></li>
          <li class="dropdown">
            <span>Más</span>
            <ul class="dropdown-content">
              <li><a href="#faq">Preguntas Frecuentes</a></li>
              <li><a href="#como-funciona">¿Cómo Funciona?</a></li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  </template>
  
  <script>
  import { ref, onMounted, watch, nextTick } from 'vue'
  import { gsap } from 'gsap'
  
  export default {
    name: 'Navbar-v',
    setup() {
      const fechaActual = ref('')
      const horaActual = ref('')
      const isOpen = ref(false)
      const menuRef = ref(null)
  
      const actualizarFechaHora = () => {
        const ahora = new Date()
        const opcionesFecha = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
        fechaActual.value = ahora.toLocaleDateString('es-MX', opcionesFecha)
        horaActual.value = ahora.toLocaleTimeString('es-MX')
      }
  
      const toggleMenu = () => {
        isOpen.value = !isOpen.value
      }
  
      watch(isOpen, async (nuevo) => {
        await nextTick()
        if (nuevo) {
          gsap.fromTo(
            menuRef.value.children,
            { y: -20, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              stagger: 0.1,
              ease: 'power2.out',
            }
          )
        }
      })
  
      onMounted(() => {
        actualizarFechaHora()
        setInterval(actualizarFechaHora, 1000)
      })
  
      return {
        fechaActual,
        horaActual,
        isOpen,
        toggleMenu,
        menuRef
      }
    }
  }
  </script>
  
  <style scoped>
  .navbar-header {
    position: fixed;
    width: 100%;
    z-index: 99999;
  }
  
  .top-bar {
    background: #333;
    color: white;
    padding: 6px 20px;
    font-size: 0.9rem;
    text-align: right;
  }
  
  /* NAVBAR */
  .navbar {
    background-color: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 25px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
  }
  
  /* LOGO */
  .logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .logo img {
    width: 140px;
  }
  .brand-name {
    font-weight: bold;
    font-size: 1.2rem;
    color: #333;
  }
  .brand-name strong {
    font-family: 'serenety';
    font-size: 1.5rem;
    color: #444;
  }
  
  /* NAV LINKS */
  .nav-links {
    list-style: none;
    display: flex;
    gap: 25px;
    margin: 0;
    padding: 0;
  }
  .nav-links li a,
  .nav-links li span {
    text-decoration: none;
    color: #333;
    font-weight: 500;
    cursor: pointer;
  }
  .nav-links li a:hover {
    color: #555;
  }
  
  /* DROPDOWN */
  .dropdown {
    position: relative;
  }
  .dropdown-content {
    display: none;
    position: absolute;
    background: white;
    top: 35px;
    left: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 10px 0;
    min-width: 180px;
    z-index: 99;
  }
  .dropdown:hover .dropdown-content {
    display: block;
  }
  .dropdown-content li {
    padding: 8px 20px;
  }
  .dropdown-content li a {
    color: #333;
  }
  
  /* HAMBURGER */
  .hamburger {
    display: none;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
  }
  .hamburger span {
    height: 3px;
    width: 25px;
    background: #333;
    transition: all 0.3s;
    border-radius: 2px;
  }
  .hamburger span.open:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }
  .hamburger span.open:nth-child(2) {
    opacity: 0;
  }
  .hamburger span.open:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }
  
  /* RESPONSIVE MENU */
  @media (max-width: 768px) {
    .hamburger {
      display: flex;
    }
  
    .nav-links {
      position: absolute;
      top: 70px;
      right: 0;
      background: white;
      flex-direction: column;
      width: 100%;
      gap: 15px;
      padding: 20px;
      transform: translateY(-100%);
      transition: all 0.4s ease;
      opacity: 0;
      pointer-events: none;
    }
  
    .nav-links.show {
      transform: translateY(0);
      opacity: 1;
      pointer-events: auto;
    }
  
    .dropdown-content {
      position: static;
      box-shadow: none;
    }
  
    .dropdown:hover .dropdown-content {
      display: none;
    }
  
    .dropdown span::after {
      content: ' ▼';
      font-size: 0.7rem;
    }
  
    .dropdown span {
      display: block;
    }
  
    .dropdown-content {
      display: block;
      padding-left: 15px;
    }
  }
  </style>
  